import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import SlideTransition from 'legacy/src/utility/Slide';
import RichText from 'legacy/src/utility/RichText';
import { lockable } from '../shared/status';

import './pageset.scss';

class Player extends Component {
  parseTitle = (title) => {
    if (title && typeof title === 'object') {
      if (title.content && title.content.length) {
        const payload = title.content[0];
        if (payload.type === 'text') {
          return payload.text;
        }
        return this.parseTitle(title.content[0]);
      }
    }

    return title;
  };

  render() {
    const {
      item: { content },
      view,
      childPlayer,
      context: { hDepth = 0 },
    } = this.props;
    const page = content.items[view.current];

    if (content.items.length === 0) {
      return null;
    }

    const title = this.parseTitle(page.title);

    return (
      <SlideTransition
        className={cn('pageset', { pageset__first: hDepth === 0 })}
      >
        <div className="pageset__inner">
          <div className="pageset__header">
            {page && page.title ? (
              <h2 className="pageset__heading">{title}</h2>
            ) : null}
            {page && page.description ? (
              <RichText content={page.description} />
            ) : null}
          </div>
          <div
            className={cn('pageset__child', {
              'pageset__first-child': hDepth === 0,
            })}
          >
            {childPlayer(view.current, page, {
              hDepth: hDepth + (page.title ? 1 : 0),
            })}
          </div>
        </div>
      </SlideTransition>
    );
  }
}

Player.propTypes = {
  item: PropTypes.object,
  view: PropTypes.object,
  childPlayer: PropTypes.func,
  context: PropTypes.object,
};

class PagesetPrint extends Component {
  render() {
    const {
      item: { content },
      childPlayer,
      context: { hDepth = 0 },
    } = this.props;
    return (
      <div>
        {content.items.map((page, index) => (
          <div className="pageset__inner" key={index}>
            <div className="pageset__header">
              {page && page.title ? (
                <h2 className="pageset__heading">{page.title}</h2>
              ) : null}
              {page && page.description ? (
                <RichText content={page.description} />
              ) : null}
            </div>
            <div
              className={cn('pageset__child', {
                'pageset__first-child': hDepth === 0,
              })}
            >
              {childPlayer(index, page, {
                hDepth: hDepth + (page.title ? 1 : 0),
              })}
            </div>
          </div>
        ))}
      </div>
    );
  }
}

PagesetPrint.propTypes = {
  item: PropTypes.object,
  childPlayer: PropTypes.func,
  context: PropTypes.object,
};

export default {
  Player,
  Print: PagesetPrint,
  paged: true,
  status: lockable,
};
